import { nullToZero, nullToEmptyString } from "src/app/shared/helpers/shared-zero-to-null.function";
import { ExtRfrOrdSaveQueryI } from "./rfr-ord-save.query.ext";
import { RfrOrdSaveQueryI } from "./rfr-ord-save.query.int";
import { ExtRfrOrdSaveI } from "./rfr-ord-save.result.ext";
import { RfrOrdSaveI } from "./rfr-ord-save.result.int";

export const MapRfrOrdSave = {
  mapQuery: (int: RfrOrdSaveQueryI): ExtRfrOrdSaveQueryI => ({
    request: {
        piSeqnr: nullToZero(int.seqNr),
        pcAction: nullToEmptyString(int.action),
    }
  }),
  mapResult: (_ext: ExtRfrOrdSaveI): RfrOrdSaveI =>  ({
  }),
};